import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useServiceAuth } from '@/contexts/ServiceAuthContext';

interface ServiceProtectedRouteProps {
  children: ReactNode;
}

export function ServiceProtectedRoute({ children }: ServiceProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useServiceAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/service/login" replace />;
  }

  return <>{children}</>;
} 